/*
 * Authors: mariushirjanu
 * Created: 16/02/2022
 */
import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Button } from '../../app-styles';

@Component({
  selector: 'button-addon',
  template: `
    <button class="btn" [class]="buttonClass || '${Button.PRIMARY}'" (click)="onClick.emit()" [busyButton]="busy()" [bbPreventDisable]="true" [bbReplaceIcon]="true" [bbIconMargin]="true" [disabled]="disable() || busy()" [title]="title | translate">
      <i *ngIf="icon" class="fa {{icon}}">&nbsp;</i>{{label | translate}}
    </button>
  `,
  styleUrls: ['./addons.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonAddonComponent {
  @Input() public label?:string;
  @Input() public icon?:string;
  @Input() public buttonClass?:string;
  @Input() public title?:string;
  @Input() public busyOnClick:boolean;
  @Input() public busy: () => boolean = () => false;
  @Input() public disable: () => boolean = () => false;
  @Output() public onClick:EventEmitter<void> = new EventEmitter<void>();

  constructor(
  ) {
    /***/
  }
}